module.exports = __webpack_public_path__ + "img/discord_minecraft.1c663500.png";